module.exports = __webpack_public_path__ + "img/8437a14.jpg";